import React from "react"
import Img from "gatsby-image"

import { Media, Text, Wrapper } from "./styles"

const Testimonial = ({ children, image, background, nospace }) => (
  <Wrapper nospace={nospace}>
    <Media>
      <Img fixed={image} alt="" />
    </Media>
    <Text background={background}>{children}</Text>
  </Wrapper>
)

export default Testimonial
